import { WORD, DROPPED } from "@/payroll/editor/diff-marks";
import type { RosterMember, RosterField } from "@/payroll/editor/types";
import { formatRosterValue } from "@/payroll/roster/utils";
export const RosterCell = ({
  member,
  field,
}: {
  member: RosterMember;
  field: RosterField;
}) => {
  const change = member.field_changes[field.key];
  const value = formatRosterValue(member.values[field.key], field);
  if (!change) return <span className="text-subtle">{value}</span>;
  const before = formatRosterValue(change.before, field);
  const after = formatRosterValue(change.after, field);
  if (member.change === "added")
    return <mark className={WORD.added}>{after}</mark>;
  if (member.change === "removed")
    return <mark className={DROPPED}>{before}</mark>;
  // Colour and a strike say which is which to anyone who can see them. Read
  // aloud, the cell was two values in a row with nothing between them, so a
  // rate going from $20 to $25 was "20 25".
  return (
    <span className="whitespace-nowrap">
      <span className="sr-only">Previously </span>
      <mark className={DROPPED}>{before}</mark>{" "}
      <span className="sr-only">Now </span>
      <mark className={WORD.added}>{after}</mark>
    </span>
  );
};
